import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/company';
const base = 'flex items-center gap-2 rounded-full p-3.5 text-sm font-bold text-white shadow-[0_10px_30px_-8px_rgba(0,0,0,0.7)] transition-[filter,background-color] duration-150 ease-out hover:brightness-110 sm:px-[18px] sm:py-3';
export function FloatingSupport() {
  return <div className="fixed bottom-[18px] right-[18px] z-[70] flex flex-col items-end gap-2.5" data-id="element-37" data-mp="2nrwhgzx8cyuo">
      <a href={company.phoneHref} aria-label="Llamar a soporte" className={`${base} border border-line bg-[#26262c]`} data-id="element-38" data-mp="2rthucl9rld4v">
        <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-39" data-mp="2ws2t0g9dbor7" />
        <span className="hidden sm:inline" data-id="element-40" data-mp="2wqi00v2pcdvg">Llamar a soporte</span>
      </a>
      <a href={company.supportMailto} aria-label="Contactar soporte por email" className={`${base} bg-accent`} data-id="element-41" data-mp="31kvzp9oed75x">
        <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="243njg9909yn9" />
        <span className="hidden sm:inline" data-id="element-43" data-mp="2928hq34p6892">Soporte por email</span>
      </a>
    </div>;
}